import React from 'react';
import { ConfiguratorUIElementStates } from '@/stores/CfgUIElementState';
import classNames from 'classnames';
import { IUiCfgContainer } from '@canvas-logic/clp-api-types';

export const ProductsContainerCfgUIElement = ({
  viewElement,
  childrenElements,
}: {
  childrenElements: ConfiguratorUIElementStates[];
  viewElement: IUiCfgContainer;
}) => {
  const productSettings = viewElement.productsSettings!;
  const layout = productSettings.layout;
  const childrens = childrenElements.map((child) => child.render());
  if (childrens.length === 0 || childrens.every((it) => it === null)) {
    return null;
  }
  return (
    <div
      className={classNames(
        'cp-product-container',
        layout === 'card' ? 'cp-product-container--card' : 'cp-product-container--list',
      )}
    >
      {childrens}
    </div>
  );
};
